import { useState, useCallback } from 'react';
import { Recipe } from '../types';

interface UseUIReturn {
  // XP State
  showXP: boolean;
  xpAmount: number;
  awardXP: (amount: number, callback?: (amount: number) => void) => void;
  hideXP: () => void;

  // Toast State
  showToast: boolean;
  toastMessage: string;
  showToastMessage: (message: string) => void;
  hideToast: () => void;

  // Plan Modal State
  showPlanModal: boolean;
  setShowPlanModal: (show: boolean) => void;
  selectedRecipeForPlan: Recipe | null;
  setSelectedRecipeForPlan: (recipe: Recipe | null) => void;
  handleAddToPlanStart: (recipe: Recipe, setShowModal: (show: boolean) => void) => void;
}

export const useUI = (): UseUIReturn => {
  // XP State
  const [showXP, setShowXP] = useState(false);
  const [xpAmount, setXpAmount] = useState(0);

  // Toast State
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  // Plan Modal State
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [selectedRecipeForPlan, setSelectedRecipeForPlan] = useState<Recipe | null>(null);

  // Award XP
  const awardXP = useCallback((amount: number, callback?: (amount: number) => void) => {
    setXpAmount(amount);
    setShowXP(true);
    if (callback) {
      callback(amount);
    }
    setTimeout(() => setShowXP(false), 1500);
  }, []);

  const hideXP = useCallback(() => {
    setShowXP(false);
  }, []);

  // Show Toast Message
  const showToastMessage = useCallback((message: string) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2500);
  }, []);

  const hideToast = useCallback(() => {
    setShowToast(false);
  }, []);

  // Handle Add To Plan Start
  const handleAddToPlanStart = useCallback((recipe: Recipe, setShowModal: (show: boolean) => void) => {
    setSelectedRecipeForPlan(recipe);
    setShowModal(true);
  }, []);

  return {
    showXP,
    xpAmount,
    awardXP,
    hideXP,
    showToast,
    toastMessage,
    showToastMessage,
    hideToast,
    showPlanModal,
    setShowPlanModal,
    selectedRecipeForPlan,
    setSelectedRecipeForPlan,
    handleAddToPlanStart,
  };
};
